__turbopack_context__.v({
  "arrow": "ActionCard-module-scss-module__ld9qFW__arrow",
  "card": "ActionCard-module-scss-module__ld9qFW__card",
  "description": "ActionCard-module-scss-module__ld9qFW__description",
  "icon": "ActionCard-module-scss-module__ld9qFW__icon",
  "link": "ActionCard-module-scss-module__ld9qFW__link",
  "text": "ActionCard-module-scss-module__ld9qFW__text",
  "title": "ActionCard-module-scss-module__ld9qFW__title",
});
